import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';
import uk from './locales/uk.json';
import es from './locales/es.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import zh from './locales/zh.json';
import pt from './locales/pt.json';

// Interface languages we ship translations for.
const SUPPORTED = ['en', 'ru', 'uk', 'es', 'de', 'fr', 'zh', 'pt'];

// New visitors default to English; a returning user keeps whatever they last chose. (We do NOT
// auto-switch to the browser language — a fresh user should always land in English.)
const getInitialLanguage = (): string => {
  const stored = localStorage.getItem('language');
  return stored && SUPPORTED.includes(stored) ? stored : 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      uk: { translation: uk },
      es: { translation: es },
      de: { translation: de },
      fr: { translation: fr },
      zh: { translation: zh },
      pt: { translation: pt },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Keep <html lang> in step with the interface language.
//
// index.html ships lang="ru", but new visitors get English and JoinGame switches the whole UI to
// the host's game language on the fly. A screen reader picks its voice and pronunciation rules
// from this attribute alone, so a stale value means a Russian synthesiser reading English
// letter-by-letter transliteration — unusable for an audio-first game, in all eight languages.
const applyDocumentLang = (lng: string) => {
  if (typeof document !== 'undefined') document.documentElement.lang = lng;
};

applyDocumentLang(i18n.language);

// Save language changes to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
  applyDocumentLang(lng);
});

export default i18n;
